import Dialog from '@/js/components/Dialog'
import DialogForm from '@/js/components/DialogForm'

export default class DialogResetPassword extends DialogForm {
    name = 'reset-password'

    onSubmitSuccess(response) {
        Dialog.show('reset-password-success', {
            message: response.message,
        })
    }

    afterHide() {
        const url = new URL(document.location)
        if (url.searchParams.has('reset-password-token')) {
            history.replaceState(null, null, '/')
        }
    }
}
